import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import config from "../config";
import {
 message
} from "antd";

import {
  action,
  makeObservable,
  observable,

  autorun,
  runInAction  

} from "mobx";



class DriverComplainReportStore {
  driverComplainStore = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      driverComplainStore: observable,
      loadData: action,

      exportExcel:action
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, driverId, offset, limit, fromDate, toDate }) {
    // console.log("vehicle list");
    var postData = {
      companyId: companyId,
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: 1,
    };

    if(config.pythonReport === 1){
          var response = await postApi.getClient('report').post("/driver_report/driverComplain", postData);
    }else{
          const base64Input = await base64_encode(JSON.stringify(postData));
          response = await postApi.getClient().post("index.php?c=driver&a=getdrivercomplain","postData=" + base64Input);
    }

    this.driverComplainStore = response?.data?.data?.complains;
  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if(config.pythonReport === 1){    
      try {
          var response = await postApi.getClient("report").post("/driver_report/driverComplain/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Driver Complain Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
          let lang = "english";
          window.location.href =
            baseURL +
            "index.php?c=driver&a=exportdrivercomplainExcel&cid=" +
            getData.companyId +
            "&userId=" +
            getData.userId +
            "&did=" +
            getData.DriverId +
            "&fD=" +
            getData.fromDate +
            "&tD=" +
            getData.toDate +
            "&colList=" +
            getData.colList;
    }
  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){    
      try {

        var response = await postApi.getClient("report").post("/driver_report/driverComplain/download/pdf", getData, {
            responseType: "blob",
        });
    
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Driver Complain Report.pdf";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        // console.log("getData", getData);
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=driver&a=exportdrivercomplainPdf&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId +
          "&did=" +
          getData.DriverId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList;
    }
  }

  async exportcsv(getData) {
    console.log("getData", getData);
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportdrivercomplainCsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.DriverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  async exportxml(getData) {
    console.log("getData", getData);
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportdrivercomplainXml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.DriverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  
}

export default DriverComplainReportStore;
